import { Select, Table } from "antd";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Head from "../../Components/Head";
import { useColumns } from "./useColumns";
import { statusOptions } from "../../data";
import styleUnityScene from "./UnityScene.module.css";
import { useGetUnityScenesList } from "../../api/unityScene";
import { CONFIG } from "../../config";

const UnityScene = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [status, setStatus] = useState("");
  const [filters, setFilters] = useState({ name: "", status: "" });
  const { data, isLoading, isFetching, isError, error, refetch } =
    useGetUnityScenesList({ limit, offset, ...filters });
  const { columns } = useColumns(refetch);

  const handleSearch = () => {
    setFilters({
      name: name,
      status: status,
    });
  };

  const dataWithKeys = data?.data?.map((unityScene, index) => ({
    ...unityScene,
    unity_file: `${CONFIG.S3_BASE_URI}/${unityScene?.unity_file}`,
    key: unityScene?.id,
    sn: offset + (index + 1),
  }));
console.log("dataWithKeys", dataWithKeys);
  const onChange = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra);
    setLimit(pagination?.pageSize);
    setOffset((pagination?.current - 1) * pagination?.pageSize);
  };

  return (
    <main className={styleUnityScene["unity-scene-main-container"]}>
      <Head title="Unity Scene" />
      <div className={styleUnityScene["unity-scene-form"]}>
        <div className={styleUnityScene["unity-scene-input-go-btn-container"]}>
          <input
            type="text"
            placeholder="Search by File Name"
            onChange={(event) => {
              setName(event.target.value);
            }}
          />
          <Select
            options={statusOptions}
            placeholder="Search by Status"
            onChange={value => setStatus(value)}
          />
          <button onClick={handleSearch}>Go</button>
        </div>
        <div className={styleUnityScene["add-unity-scene"]}>
          <button
            onClick={() => {
              navigate("/web-twinprocms/unity-scene/create");
            }}
          >
            <FontAwesomeIcon icon={faPlus} /> Add Unity Scene
          </button>
        </div>
      </div>
      {isError && <p>{error?.message}</p>}
      <div className={styleUnityScene["unity-scene-table-container"]}>
        <Table
          rowClassName="cursor-pointer"
          columns={columns}
          dataSource={dataWithKeys}
          onChange={onChange}
          loading={isLoading || isFetching}
          pagination={{ total: data?.total, showSizeChanger: true }}
        />
      </div>
    </main>
  );
};

export default UnityScene;
